module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    ref: "codeEditor"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-844ec646","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor/editor.vue
// module id = 522
// module chunks = 1